/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UICustomizationChallengeOptions
 */
export interface UICustomizationChallengeOptions {
    /**
     * UI configuration for the hosted page users are redirected to after clicking a magic link or password reset link.
     * @type {{ [key: string]: any; }}
     * @memberof UICustomizationChallengeOptions
     */
    authn_redirect_page_ui_config?: { [key: string]: any; };
}

/**
 * Check if a given object implements the UICustomizationChallengeOptions interface.
 */
export function instanceOfUICustomizationChallengeOptions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UICustomizationChallengeOptionsFromJSON(json: any): UICustomizationChallengeOptions {
    return UICustomizationChallengeOptionsFromJSONTyped(json, false);
}

export function UICustomizationChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UICustomizationChallengeOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'authn_redirect_page_ui_config': !exists(json, 'authn_redirect_page_ui_config') ? undefined : json['authn_redirect_page_ui_config'],
    };
}

export function UICustomizationChallengeOptionsToJSON(value?: UICustomizationChallengeOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'authn_redirect_page_ui_config': value.authn_redirect_page_ui_config,
    };
}

